import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { Switch } from "react-router";
import queryString from "query-string";
import { EventRoute } from "@minerva-analytics/pantheon";
import { Helmet } from "react-helmet";

import routes from "../../routes";
import { GOOGLE_ANALYTICS_TAG } from "../../constants";
import { GlobalStyle } from "../../index.styles";
import { PageContainer } from "./App.styles";
import { starterTheme } from "../../theme";
import Footer from "../../components/Footer";

import { saveCampaignParamsRedux } from "../../store/session/actions";
import Nav from "../../components/Nav/Nav";

const App = () => {
  const [isInitialPageView, setIsInitialPageView] = useState(true);
  const { search, pathname } = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const parsed = queryString.parse(search);

    dispatch(saveCampaignParamsRedux(parsed));
  }, []);

  return (
    <>
      <Helmet>
        <html lang="en" />
        <link rel="preconnect" href="https://connect.facebook.net/" />
        <link rel="preconnect" href="https://facebook.com" />
        <link
          rel="canonical"
          href={`https://www.thesciencespotlight.com${pathname}`}
        />
        <title>{`Today in History — An Email Newsletter | The Science Spotlight`}</title>
        <meta
          name="og:title"
          property="og:title"
          content="Today in History — An Email Newsletter | The Science Spotlight"
        />
        <meta
          name="og:description"
          property="og:description"
          content="The Science Spotlight is a daily email newsletter about science history. Learn more about us and sign up today!"
        />
        <meta
          name="description"
          property="description"
          content="The Science Spotlight is a daily email newsletter about science history. Learn more about us and sign up today!"
        />
        <meta name="og:type" property="og:type" content="website" />
        <meta
          name="og:url"
          property="og:url"
          content="https://www.thesciencespotlight.com"
        />
        <meta
          name="og:site_name"
          property="og:site_name"
          content="TheScienceSpotlight"
        />
      </Helmet>
      <ThemeProvider theme={starterTheme}>
        <GlobalStyle />
        <Nav />
        <PageContainer>
          <Switch>
            {routes.map((r) => (
              <EventRoute
                {...r}
                onPageChange={[
                  () => {
                    if (!isInitialPageView && window.gtag) {
                      window.gtag(`config`, GOOGLE_ANALYTICS_TAG, {
                        page_title: document.title,
                        page_path: pathname + search,
                      });
                    } else {
                      setIsInitialPageView(false);
                    }
                  },
                ]}
              />
            ))}
          </Switch>
        </PageContainer>
        <Footer />
      </ThemeProvider>
    </>
  );
};

export default App;
